import { join, values } from "lodash"
import PropTypes from "prop-types"
import Loading from "components/loading"
import Markdown from "markdown-to-jsx"

export default function MarkdownSummary({ isGenerated, summary, error }) {
  if (!isGenerated && !error) {
    return <Loading />
  }

  if (error) {
    return <div className="error">{error}</div>
  }

  return <Markdown>{join(values(summary), "\n")}</Markdown>
}

MarkdownSummary.propTypes = {
  isGenerated: PropTypes.bool,
  summary: PropTypes.object,
  error: PropTypes.string,
}
